import StartEndDurationUtils from "../start-end-duration/start-end-duration-utils";
import WorkScheduleProto, {WorkScheduleDayStatus} from "./work-schedule-proto";
import DatetimeUtils from "../../utils/datetime-utils"

export default class CompanyWorkSchedule extends WorkScheduleProto {

    public companyId        : ID
    // public companyWorkweek  : number[] // ? not sure
    public companyHolidays  : Set<any>  = new Set()

    constructor(companyEvents:any[]) {
        super();
        // IMPORTANT we use Set() here !

        this.companyId = gd.companyId; // just in case
        this.updateEvents(companyEvents);

        // our work week is in format mon-sun i.e. [1,1,1,1,1,0,0]
        // this.companyWorkweek = gd.company.settings.workSchedule.workWeek;

        //get workday durations
        this.workDayDurations = gd.company.settings.workSchedule.workdayDurations //[480, 0, 480, ...]
    }

    updateEvents(companyEvents:any) {
        this.companyHolidays = new Set(StartEndDurationUtils.getCompanyHolidays(companyEvents));
    }

    isHoliday(dateString:string) {
        // v buduchem nado konechno sam event eche vozvrachat' budet....
        return this.companyHolidays.has(dateString);
    }

    isWeekend(dateString:string) {
        // isoWeekday is in range 1-7, companyWorkweek is like [1,1,1,1,1,0,0] and we check for 0 value to be weekend
        // return this.companyWorkweek[moment(dateString).isoWeekday() - 1] === 0;
        return this.workDayDurations[moment(dateString).isoWeekday() - 1] === 0;
    }

    // careful with === for true
    isWorkingDay(dateString:string) {
        // let res : any = true;

        if (this.isHoliday(dateString))         return WorkScheduleDayStatus.COMPANY_HOLIDAY
        else if (this.isWeekend(dateString))    return WorkScheduleDayStatus.COMPANY_WEEKEND

        return true
    }

    getWorkdayDuration(dateMoment: Moment): number {
        return this.isWorkingDay(DatetimeUtils.momentToDate(dateMoment)!) ? this.workDayDurations[dateMoment.isoWeekday() - 1] : 0
    }
}